import React from 'react'

const PowerPointIntero = () => {
    return (
        <>
            <section style={{ marginTop: 40, marginBottom: 40 }}>
                <div className="container">
                    <div className="section-title">
                        <h2>Introduction</h2>
                        <div className="bar" />
                    </div>
                    <div className=" cd-intro-content bouncy shadow p-4 animated swing">
                        <div className="row">
                            <div className="col-md-12 allpara">
                                <h3 className="text-left mesee-mg animated fadeInUp ease-out-circ d2 a-1 f2 fw3 heading">
                                    Powerpointz
                                </h3>
                                <p>
                                    Power Pointz(PP) digital customer loyalty solution and Power Pointz
                                    E-Commerce(PPEC) are owned and operated by a Bahamian marketing
                                    company with a technology twist, Capital City Marketing, based on
                                    #53 Davis Street Nassau, The Bahamas. The marketing tools offered by
                                    this company focus on e-commerce &amp; digital customer loyalty
                                    solutions for merchants and shoppers interested in cutting edge
                                    promotion solutions, excellent online shopping and reliable customer
                                    loyalty programs. PowerPointz Customer Loyalty(PP) and PowerPointz
                                    E-Commerce(PPEC) are platforms made with
                                </p>
                            </div>
                            {/* <div className="col-lg-4 col-md-4">
                                <div className="video-responsive mt-5">
                                    <video width="100%" height={200} controls="">
                                        <source src="https://www.youtube.com/embed/tgbNymZ7vqY" />
                                    </video>
                                </div>
                            </div> */}
                        </div>
                        <div className="col-md-12 allpara p-0">
                            <p>
                                the customer in mind. Shop, Save, Earn and Redeem points and rewards!
                                In order to earn and redeem points, purchases must be made with the
                                same merchant in one order or "check-out". Our merchants are here to
                                serve you! Points and rewards will be applied to your purchase as long
                                as you and the merchants are Power Pointz loyalty program members.
                            </p>
                            <p>Shoppers</p>
                            <p>Earn points with each purchase you make</p>
                            <p>Redeem prizes</p>
                            <p>Review your transaction history</p>
                            <p>See merchant’s special offers</p>
                            <p>Track your points</p>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default PowerPointIntero